import React from 'react';
import { useNavigate } from 'react-router-dom';
import PageBackground from '../components/PageBackgroundBeam';
import PageFooter from '../components/PageFooter';
import './PageTop10Radio.css';

function formatNumber(n) {
  return n.toLocaleString('en-US', { maximumFractionDigits: 0 });
}

const RADIO_TOTAL = 36885400;

const RADIO_DATA = [
  { pos: 1,  canal: 'HRN',                slug: 'hrn',                inv: 6979156, spots: 48192,  inv6y: [6979156,8924566,10317800,11134348,17141193,10649986] },
  { pos: 2,  canal: 'RADIO AMERICA',      slug: 'radio-america',      inv: 3350691, spots: 33446,  inv6y: [3350691,7028357,6620863,7260347,10940186,6068390] },
  { pos: 3,  canal: 'RADIO CADENA VOCES', slug: 'radio-cadena-voces', inv: 2678666, spots: 42728,  inv6y: [2678666,2918239,2265661,1656899,2369876,1340876] },
  { pos: 4,  canal: 'POWER FM SPS',       slug: 'power-fm-sps',       inv: 2217287, spots: 59033,  inv6y: [2217287,2455953,2125468,0,0,0] },
  { pos: 5,  canal: 'POWER FM',           slug: 'power-fm',           inv: 1831369, spots: 48261,  inv6y: [1831369,1908257,1994703,1777573,2762173,1256074] },
  { pos: 6,  canal: 'RADIO GLOBO',        slug: 'radio-globo',        inv: 1631432, spots: 39949,  inv6y: [1631432,2468270,1956163,1574488,2053339,1008376] },
  { pos: 7,  canal: 'EXA FM SPS',         slug: 'exa-fm-sps',         inv: 1064675, spots: 37581,  inv6y: [1064675,1114502,699819,0,0,405036] },
  { pos: 8,  canal: 'MUSIQUERA SPS',      slug: 'musiquera-sps',      inv: 1040685, spots: 22390,  inv6y: [1040685,1414751,1105751,0,0,599926] },
  { pos: 9,  canal: 'W107',               slug: 'w107',               inv: 1012709, spots: 52164,  inv6y: [1012709,1185544,1396614,1496601,2399730,983988] },
  { pos: 10, canal: 'EXA FM',             slug: 'exa-fm',             inv: 947018,  spots: 31943,  inv6y: [947018,804614,773501,934274,1171595,684288] },
];

function Sparkline({ inv6y }) {
  const chronological = [...inv6y].reverse();
  const inv2025 = inv6y[0];
  const inv2020 = inv6y[5];
  const isUp = inv2025 >= inv2020;
  const color = isUp ? '#4ade80' : '#f87171';

  const w = 100;
  const h = 32;
  const padX = 3;
  const padY = 4;

  const max = Math.max(...chronological);
  const min = Math.min(...chronological);
  const range = max - min || 1;

  const points = chronological.map((val, i) => {
    const x = padX + (i / (chronological.length - 1)) * (w - padX * 2);
    const y = padY + (1 - (val - min) / range) * (h - padY * 2);
    return `${x},${y}`;
  });

  const polyline = points.join(' ');
  const firstX = padX;
  const lastX = padX + (w - padX * 2);
  const areaPoints = `${firstX},${h - padY} ${polyline} ${lastX},${h - padY}`;

  const pctChange = inv2020 > 0
    ? ((inv2025 - inv2020) / inv2020 * 100).toFixed(0)
    : null;

  return (
    <div className="spark-wrap">
      <svg width={w} height={h} viewBox={`0 0 ${w} ${h}`}>
        <defs>
          <linearGradient id={`sg-radio-${isUp ? 'u' : 'd'}`} x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor={color} stopOpacity="0.25" />
            <stop offset="100%" stopColor={color} stopOpacity="0.02" />
          </linearGradient>
        </defs>
        <polygon points={areaPoints} fill={`url(#sg-radio-${isUp ? 'u' : 'd'})`} />
        <polyline points={polyline} fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        {(() => {
          const lp = points[points.length - 1].split(',');
          return <circle cx={lp[0]} cy={lp[1]} r="2" fill={color} />;
        })()}
      </svg>
      <span className={`spark-pct ${isUp ? 'spark-up' : 'spark-down'}`}>
        {pctChange !== null ? (isUp ? '+' : '') + pctChange + '%' : 'NEW'}
      </span>
    </div>
  );
}

function PageTop10Radio() {
  const navigate = useNavigate();
  const maxInv = RADIO_DATA[0].inv;

  return (
    <PageBackground>
      <div className="top10radio-page">
        <header className="top10radio-header">
          <button className="btn-back" onClick={() => navigate('/top20-spots')}>
            &#8592; Top 20 Spots
          </button>
          <div className="top10radio-title-block">
            <h1 className="top10radio-title">Top 10 Emisoras de Radio</h1>
            <p className="top10radio-subtitle">Radio &middot; Honduras 2025 &middot; USD &middot; ${formatNumber(RADIO_TOTAL)}</p>
          </div>
          <button className="btn-next" onClick={() => navigate('/top-10-prensa')}>
            Prensa &#8594;
          </button>
          <img src={require('../assets/logo-publisearch.png')} alt="Publisearch" className="header-logo-inline" onClick={() => navigate('/')} style={{ cursor: 'pointer' }} />
        </header>

        <div className="top10radio-table-wrap">
          <table className="radio-table">
            <thead>
              <tr>
                <th className="rt-pos">#</th>
                <th className="rt-name">Emisora</th>
                <th className="rt-inv">Valor Mercado</th>
                <th className="rt-pct">%</th>
                <th className="rt-spots">Spots</th>
                <th className="rt-spark">Inv. 6Y</th>
              </tr>
            </thead>
            <tbody>
              {RADIO_DATA.map((row, idx) => {
                const pct = (row.inv / RADIO_TOTAL) * 100;
                return (
                  <tr key={row.pos} className="rt-row" style={{ animationDelay: `${idx * 0.05}s` }}>
                    <td className="rt-pos">
                      <span className={`rt-pos-badge ${row.pos <= 3 ? 'rt-pos-top3' : ''}`}>
                        {row.pos}
                      </span>
                    </td>
                    <td className="rt-name">
                      <span className="rt-canal-name rt-canal-link" onClick={() => navigate(`/top25-radio/${row.slug}`)}>{row.canal}</span>
                      <div className="rt-bar-bg">
                        <div className="rt-bar" style={{ width: `${(row.inv / maxInv) * 100}%` }}></div>
                      </div>
                    </td>
                    <td className="rt-inv">${formatNumber(row.inv)}</td>
                    <td className="rt-pct">{pct.toFixed(2)}%</td>
                    <td className="rt-spots">{formatNumber(row.spots)}</td>
                    <td className="rt-spark"><Sparkline inv6y={row.inv6y} /></td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

        <PageFooter />
      </div>
    </PageBackground>
  );
}

export default PageTop10Radio;
